<template>

  <div>
    <template>
      <div class="vOuNMdnnwBYWCv2S5q3w false" id="navigator" style="background-color: transparent;">
        <div class="item" @click="foot_go(1)">
          <span :class="foot_type == 1 ? 'ic home active' : 'ic home false'"></span>
          <span :class="foot_type == 1 ? 'text active' : 'text'" >首页</span>
        </div>
        <div class="item" @click="foot_go(2)">
          <span :class="foot_type == 2 ? 'ic promotion active' : 'ic promotion false'"></span>
          <span  :class="foot_type == 2 ? 'text active' : 'text'" >活动</span>
        </div>
        <div class="item"  style="opacity: 0.8;" @click="foot_go(3)">
          <span class="asSportsLive"></span>
        </div>
        <div class="item" @click="foot_go(4)">
          <span :class="foot_type == 4 ? 'ic deposit active' : 'ic deposit false'"></span>
          <span :class="foot_type == 4 ? 'text active' : 'text'" >充值</span>
        </div>
        <div class="item" @click="foot_go(5)">
          <span :class="foot_type == 5 ? 'ic cs active' : 'ic cs false'"></span>
          <span  :class="foot_type == 5 ? 'text active' : 'text'">我的</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SpecialPage',

  data() {
    return {
      originalFontSize: '',
      foot_type:1,//1 首页 2 活动 3中间  4 充值 5我的
    }
  },
  created() {
    if(this.$route.path == '/'){
        this.foot_type = 1;

    } else if(this.$route.path == '/activity'){
      this.foot_type = 2;
    } else if(this.$route.path == '/zhongjian'){
      this.foot_type = 3;
    } else if(this.$route.path == '/recharge'){
      this.foot_type = 4;

    } else if(this.$route.path == '/mine'){
      this.foot_type = 5;
    }
  },
  methods: {
    foot_go(val) {
      if(this.foot_type == val){
        return false;
      }
      if(val == 1){
        this.$parent.goNav('/');
      } else if(val == 2){
        this.$parent.goNav('/activity');
      } else if(val == 3){
        this.$parent.goNav('/zhongjian');
      } else if(val == 4){
        this.$parent.goNav('/recharge');
      } else if(val == 5){
        this.$parent.goNav('/mine');
      }
    },

  },

}
</script>


<style scoped>


.vOuNMdnnwBYWCv2S5q3w {
  font-size: 12px;
  //font-size: 14px;

  background: url(/static/bg-tab.f4c2.png) no-repeat center / 100% 100%;

  //height: 3.4867rem;
  height: 3rem;
  width: 100%;
  background-size: 100% 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 11;
  display: flex;
}

.vOuNMdnnwBYWCv2S5q3w> .item {
  align-items: center;

  width: 20%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

 .vOuNMdnnwBYWCv2S5q3w>div.item>span.ic.home.active {
  background-image: url(/static/foot/home.328f.png);
}
 .vOuNMdnnwBYWCv2S5q3w>div.item>span.ic.home {
  background-image: url(/static/foot/home-act.9378.png);
}
 .vOuNMdnnwBYWCv2S5q3w>div.item>span.ic {
  //margin: 1.0667rem 0 0 0;
   margin: 0.7rem 0 0 0;
}
.vOuNMdnnwBYWCv2S5q3w>div.item>span.ic {
  width: 1.37rem;
  height: 1.25rem;
  display: inline-block;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
div, span, a {
  user-select: none;
  -webkit-overflow-scrolling: touch;
}

 .vOuNMdnnwBYWCv2S5q3w>div.item>span.ic.promotion.active {
  background-image: url(/static/foot/promotions.0705.png);
}
 .vOuNMdnnwBYWCv2S5q3w>div.item>span.ic.promotion {
  background-image: url(/static/foot/promotions-act.5c27.png);
}


 .vOuNMdnnwBYWCv2S5q3w>div.item>span.asSportsLive {
  top: -1.4667rem;
  background-image: url(/static/foot/my.1044.png);
}
.vOuNMdnnwBYWCv2S5q3w>div.item>span.asSportsLive {
  left: 50%;
  transform: translate(-50%, 0%);
  position: absolute;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 4.4375rem;
  height: 4.46875rem;
  width: 4rem;
  height: 4rem;
}


.vOuNMdnnwBYWCv2S5q3w>div.item>span.ic.deposit {
  background-image: url(/static/foot/deposit-act.7fb8.png);
}


 .vOuNMdnnwBYWCv2S5q3w>div.item>span.ic.cs.active {
  background-image: url(/static/foot/myself.ca02.png);
}
.vOuNMdnnwBYWCv2S5q3w>div.item>span.ic.cs {
  background-image: url(/static/foot/myself-act.1d70.png);
}

.vOuNMdnnwBYWCv2S5q3w>div.item>span.text {
  color: #c6c6c6;
}


.vOuNMdnnwBYWCv2S5q3w>div.item>span.text.active {
  color: #fff;
}

.vOuNMdnnwBYWCv2S5q3w>div.item>span.text {
  display: flex;
  margin-bottom: auto;
  width: 100%;
  justify-content: center;
  color: #fff;
}
.vOuNMdnnwBYWCv2S5q3w>div.item>span.text {
  color: #c6c6c6;
}

 .vOuNMdnnwBYWCv2S5q3w>div.item>span.text.active {
  color: #000;
}

</style>